import { LOCALE_TO_MANUS_LANG, type AppLocale } from '@/constants/appLocale'

/** Manus 目的地嵌入页（与站点 i18n 语言同步） */
export const MANUS_SPACE_ORIGIN = 'https://bilionpass-o4kcbg3k.manus.space' as const

export const MANUS_DESTINATION_SLUGS = [
  'fuji',
  'kiyomizu',
  'sensoji',
  'nara',
  'tokyo-tower',
  'yasaka',
] as const

export type ManusDestinationSlug = (typeof MANUS_DESTINATION_SLUGS)[number]

export function i18nToManusLang(i18nLanguage: string): 'zh' | 'ja' | 'en' {
  if (i18nLanguage in LOCALE_TO_MANUS_LANG) {
    return LOCALE_TO_MANUS_LANG[i18nLanguage as AppLocale]
  }
  return 'zh'
}

export function isManusDestinationSlug(s: string): s is ManusDestinationSlug {
  return (MANUS_DESTINATION_SLUGS as readonly string[]).includes(s)
}

export function buildManusDestinationUrl(slug: ManusDestinationSlug, i18nLanguage: string) {
  const lang = i18nToManusLang(i18nLanguage)
  return `${MANUS_SPACE_ORIGIN}/destination/${slug}?lang=${lang}`
}
